<template>
  <div class="no-auth">
    <img src="@/assets/image/noauth.png" alt="" />
    <p>抱歉，您没有权限访问</p>
    <van-button v-if="!isWx" @click="back" round type="info" block>确定</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isWx: localStorage.getItem('env') === 'vx'
    }
  },
  methods: {
    back() {
      if (window.history.length <= 1) {
        this.$router.push('/home')
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.no-auth {
  height: 100vh;
  padding: 20px;
  padding-top: 160px;
  text-align: center;
  img {
    width: 200px;
  }
  p {
    font-weight: 700;
    color: #303133;
    margin-bottom: 40px;
  }
}
</style>
